import React, { useEffect, useState } from "react";
import WhiteNavbar from "components/Navbars/WhiteNavbar";
import Footer from "components/Footers/Footer";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";

// 🔹 src/assets/img/presentation-page klasöründeki tüm fotoğrafları al
const importAll = (r) => r.keys().map(r);
const galleryImages = importAll(
  require.context("../assets/img/presentation-page", false, /\.(jpg|jpeg|png)$/)
);

const PhotoGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    AOS.init({ once: true, duration: 500, easing: "ease-out" });
  }, []);

  useEffect(() => {
    const targetLink = document.querySelector('a[data-gt-lang="tr"]');
    if (targetLink) {
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      if (imgElement) {
        imgElement.src = "https://cdn.gtranslate.net/flags/32/tr.png";
        imgElement.width = 32;
        imgElement.height = 32;
      }
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>FOTOĞRAF GALERİMİZ | EKŞİOĞLU HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Ekşioğlu Hukuk Ofisi'nin etkinliklerinden, ofis ortamından ve çalışmalarından kareleri keşfedin."
        />
        <link
          rel="canonical"
          href="https://www.eksiogluhukukofisi.com/fotograflar"
        />
        <meta
          property="og:title"
          content="FOTOĞRAF GALERİMİZ | EKŞİOĞLU HUKUK"
        />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="EKŞİOĞLU HUKUK" />
        <meta
          property="og:image"
          content="https://www.eksiogluhukukofisi.com/static/media/eksiogluWhiteLogo.e14b5e9c41e5271d670c.png"
        />
        <meta
          property="og:url"
          content="https://www.eksiogluhukukofisi.com/fotograflar"
        />
      </Helmet>

      {/* Navbar */}
      <WhiteNavbar navbarSelection={"photos"} />
      <div className="mt-[80px]" />

      {/* Galeri Başlığı */}
      <section className="w-full flex flex-col items-center bg-white px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-8 md:py-12 font-sans">
        <div className="w-full max-w-6xl" data-aos="fade-up">
          <div className="flex items-center mb-8">
            <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
            <h2 className="mx-4 text-2xl md:text-3xl font-extrabold text-slate-900 leading-tight text-center">
              Fotoğraf Galerimiz
            </h2>
            <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
          </div>

          <p className="text-center text-gray-600 text-base md:text-lg mb-10">
            Ofisimizden, etkinliklerimizden ve hukuk dünyasındaki
            çalışmalarımızdan kareler.
          </p>

          {/* Galeri Grid */}
          <div
            className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            {galleryImages.map((img, index) => (
              <div
                key={index}
                className="relative group cursor-pointer overflow-hidden rounded-lg shadow-md"
                onClick={() => setSelectedImage(img)}
              >
                <img
                  src={img}
                  alt={`Galeri Fotoğrafı ${index + 1}`}
                  className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center text-white text-sm font-semibold">
                  Büyüt
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox - Tıklanan fotoğraf büyüsün */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-[9999] p-4 cursor-zoom-out"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Büyük Görsel"
            className="max-h-[90vh] max-w-[95vw] rounded-lg shadow-2xl animate-fade-in"
          />
          <button
            className="absolute top-5 right-8 text-white text-3xl font-bold hover:scale-110 transition-transform"
            aria-label="Kapat"
            onClick={() => setSelectedImage(null)}
          >
            ×
          </button>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </>
  );
};

export default PhotoGallery;
